module.exports = __webpack_public_path__ + "static/media/weekend_cropped.3573b056.png";